import {
  CUSTOM_COMPANIES_PATH,
  FAVORITES_PATH,
  FUNDS_AND_PORTFOLIOS_PATH,
  MANAGE_ACCESS_PATH,
} from '@upright/ui/common/generic/components/navigation/page-paths';
import { lazy } from 'react';
import { RouteDatum } from '../types';

const CompanyDashboard = lazy(async () => await import('@upright/ui/views/home-views/company-dashboard-view'));
const InvestorHomeView = lazy(async () => await import('@upright/ui/views/home-views/organizations-assets-view'));
const FavoritedEntitiesView = lazy(async () => await import('@upright/ui/views/home-views/favorited-entities-view'));
const MySharedAssetsView = lazy(async () => await import('@upright/ui/views/home-views/my-shared-assets-view'));
const CustomCompaniesView = lazy(async () => await import('@upright/ui/views/home-views/custom-companies-view'));

/**
 * `/` without its leading slash. These paths stay relative, because `useShouldShowHomeViewFrame`
 * compares their first segment with the current one.
 */
const relative = (path: string) => path.replace(/^\//, '');

export const homeViewRoutes: RouteDatum[] = [
  { path: relative(FAVORITES_PATH), element: <FavoritedEntitiesView /> },
  { path: relative(MANAGE_ACCESS_PATH), element: <MySharedAssetsView /> },
  { path: relative(FUNDS_AND_PORTFOLIOS_PATH), element: <InvestorHomeView /> },
  { path: 'company-dashboard', element: <CompanyDashboard /> },
  { path: relative(CUSTOM_COMPANIES_PATH), element: <CustomCompaniesView /> },
  { path: 'custom-companies/organizations/:organizationId/create-company', element: <CustomCompaniesView /> },
  {
    path: 'custom-companies/organizations/:organizationId/create-company/:companyId',
    element: <CustomCompaniesView />,
  },
  {
    path: 'custom-companies/organizations/:organizationId/create-company/:companyId/review-products',
    element: <CustomCompaniesView />,
  },
  {
    // PLT-6998 — the wizard's sites step; spelled like `REVIEW_SITES_SEGMENT`.
    path: 'custom-companies/organizations/:organizationId/create-company/:companyId/review-sites',
    element: <CustomCompaniesView />,
  },
  // PLT-6276 — the Edit company dialog, on its default tab or on the one a list count opens.
  { path: 'custom-companies/organizations/:organizationId/edit-company/:companyId', element: <CustomCompaniesView /> },
  {
    path: 'custom-companies/organizations/:organizationId/edit-company/:companyId/:tab',
    element: <CustomCompaniesView />,
  },
];
